<template>
  <div>
    <Sliders></Sliders>
    <WhoWeAre></WhoWeAre>
    <Why2PayMe></Why2PayMe>
    <Background></Background>
    <OurServices></OurServices>
    <WorkFields></WorkFields>
    <Clients></Clients>
    <FAQs></FAQs>
    <Testimonials></Testimonials>
    <Download></Download>
  </div>
</template>

<script>

export default {
  name: 'List',
  components: {
    Sliders: () => import("@/components/Sliders.vue"),
    Background: () => import("@/components/Background.vue"),
    WhoWeAre: () => import("@/components/WhoWeAre.vue"),
    OurServices: () => import("@/components/OurServices.vue"),
    Clients: () => import("@/components/Clients.vue"),
    WorkFields: () => import("@/components/WorkFields.vue"),
    Why2PayMe: () => import("@/components/Why2PayMe.vue"),
    FAQs: () => import("@/components/FAQs.vue"),
    Testimonials: () => import("@/components/Testimonials.vue"),
    Download: () => import("@/components/Download.vue"),
  },
  data() {
    return {
      //
    }
  },
  mounted() {
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
